import { Injectable } from '@angular/core';
import { Theme } from '../theme/theme';

@Injectable({
  providedIn: 'root'
})
export class TemaVerificarService {
  constructor() { }

  VerificarTemaActivo(): string {
    if (window) {
      if (window.location) {
        if (window.location.href) {
          if (window.location.href.includes('sura.gag.com.co')) {
          // if (window.location.href.includes('localhost:4200')) {
            return Theme.sura;
          } else if (window.location.href.includes('aquashield.gag.com.co')) {
            // if (window.location.href.includes('localhost:4200')) {
              return Theme.aquashield;
          } else if (window.location.href.includes('cobelen.gag.com.co')) {
            // if (window.location.href.includes('localhost:4200')) {
              return Theme.cobelen;
          }
        }
      }

    }

    return Theme.global;
  }
}
